(() => {
  document.querySelectorAll('[data-kalia-country-chooser] form').forEach((form) => {
    form.addEventListener('submit', () => {
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) {
        returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      }
    });
  });
})();
